import { useQuery } from 'react-query';
import { useServices } from '../../../services/useServices';
import { IAuthorRelationshipSummaryResponseDto } from '../book.dto';
import { AUTHOR_RELATIONSHIP_STALE_MS } from './useAuthorRelationship';

/**
 * Runs only once the user opens the "Summarize author relationship" bar (`enabled`).
 * `dataVersion` is the deals read's `fetched_at`, so a Refresh re-summarizes while the
 * bar is open; the backend returns its cached summary when nothing changed in HubSpot.
 */
export const useAuthorRelationshipSummary = (
  author: string,
  enabled: boolean,
  dataVersion?: string
) => {
  const {
    book: { summarizeAuthorRelationship }
  } = useServices();

  const res = useQuery<IAuthorRelationshipSummaryResponseDto>(
    ['author-relationship-summary', author, dataVersion],
    () => summarizeAuthorRelationship(author),
    {
      enabled: enabled && Boolean(author),
      staleTime: AUTHOR_RELATIONSHIP_STALE_MS,
      cacheTime: AUTHOR_RELATIONSHIP_STALE_MS * 2,
      refetchOnWindowFocus: false,
      retry: 1,
      retryDelay: 500
    }
  );

  return {
    data: res.data,
    isError: res.isError,
    isLoading: res.isLoading,
    refetch: res.refetch
  };
};
